import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import About from "@/components/About";
import WhyChoose from "@/components/WhyChoose";
import { HERO_IMAGES } from "@/data/heroImages";

export default function EcolePage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        eyebrow="L'École"
        title="Une école conçue pour ceux qui veulent changer"
        italicWord="les règles"
        subtitle="ECL Abidjan, c'est l'École de Commerce de Lyon qui déploie son excellence en Côte d'Ivoire. Une seule école, un seul niveau d'exigence, une seule promesse : les mêmes diplômes, les mêmes débouchés. Pour former des profils qui ne suivent pas les lignes… mais les déplacent."
        crumb="L'École"
        image={HERO_IMAGES.ecole}
        cta={
          <button onClick={() => navigate("/formations")} className="btn-red">
            Découvrir nos formations
            <ArrowRight className="h-4 w-4" />
          </button>
        }
      />
      <About />
      <WhyChoose />
    </>
  );
}
